import React, { useEffect } from 'react';
import { isMobileScreen } from '@apply/ui';
import { useAuthentication } from '../../Login/hooks/useAuthentication';
//import { useIdleTimer } from 'react-idle-timer';
import { Menu, MenuItem } from '@apply/components';
import { NotificationButton } from './NotificationButton';
import { ProfileButton } from './ProfileButton/ProfileButton';
import { LogoLink } from './LogoLink';
import { FeatureType } from '@apply/constants';
import { useAuthenticationStore } from '../../state/authenticationStore';

const mobileScreen = isMobileScreen();

export enum MenuItemOption {
    NoOptionSelected = 0,
    Home = 1,
    BusinessAndPeople = 2,
    Experience = 3,
    ManageUsers = 4,
}

export const Header: React.FC<{ printMode?: boolean; activeMenuItem?: MenuItemOption; showLogo?: boolean }> = ({
    printMode,
    activeMenuItem = MenuItemOption.NoOptionSelected,
    showLogo = false,
}) => {
    const selectedAuthorizedDrawUserEntity = useAuthenticationStore((s) => s.selectedEntity);
    const { authentication, isAuthenticated, isFeatureEnabled } = useAuthentication();

    // const [logoutTimeout, setLogoutTimeout] = useState<NodeJS.Timeout>();
    // const [isIdle, setIsIdle] = useState(false);
    // const idleWarningDuration = 1000 * 60 * 2;
    // const sessionDuration = 1000 * 60 * 20;
    // const idleDuration = sessionDuration - idleWarningDuration;

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    return (
        <>
            <header>
                <div
                    className='headerWrapper'
                    style={{
                        visibility: isAuthenticated || showLogo ? 'visible' : 'hidden',
                    }}
                >
                    <div className='logoWrapper'>
                        <LogoLink />
                    </div>
                    <div
                        className='menuWrapper'
                        style={{ visibility: isAuthenticated ? 'visible' : 'hidden' }}
                    >
                        {!mobileScreen && (
                            <Menu>
                                <MenuItem
                                    active={activeMenuItem == MenuItemOption.Home}
                                    hint='BFI Apply Home Page'
                                    url='/home'
                                >
                                    Home
                                </MenuItem>
                                {/* <MenuItem
                                    url='/businessandpeople'
                                    active={activeMenuItem == MenuItemOption.BusinessAndPeople}
                                    visible={authentication?.user?.isRegistered}
                                >
                                    Business & People
                                </MenuItem> */}
                                <MenuItem
                                    url='/experience'
                                    active={activeMenuItem == MenuItemOption.Experience}
                                    visible={authentication?.user?.isRegistered && !selectedAuthorizedDrawUserEntity}
                                >
                                    Experience
                                </MenuItem>
                                <MenuItem
                                    url='/manageusers'
                                    active={activeMenuItem == MenuItemOption.ManageUsers}
                                    visible={
                                        isFeatureEnabled(FeatureType.GeneralContractor) &&
                                        authentication?.user?.isRegistered &&
                                        !selectedAuthorizedDrawUserEntity
                                    }
                                >
                                    Manage Users
                                </MenuItem>
                            </Menu>
                        )}
                    </div>
                    <div className={`${printMode ? 'hidden' : 'headerNav'}`}>
                        <div className='headerNav-navItem'>
                            <NotificationButton
                                visible={authentication?.user?.isRegistered && !selectedAuthorizedDrawUserEntity}
                                printMode={printMode}
                            />
                        </div>
                        <div className='headerNav-navItem'>
                            <ProfileButton
                                user={authentication?.user}
                                printMode={printMode}
                            />
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};
